import {calcUserScore} from 'helpers/common-helper';
import {getDefaultExposure} from 'helpers/player-helper';
import BasePlayer from 'services/sports/cfb/player/player';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';
import Const from 'constants';
import Action from 'actions';

export default class Player extends BasePlayer {
    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            teamTotal: parseFloat(expandedPlayer.teamTotal),
            userPoints,
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
                this.captain_exposureMin = getDefaultExposure('min');
                this.captain_exposureMax = getDefaultExposure('max');
            },
            isFitForLineup(substitutablePlayer) {
                const substitutePlayerLineupPositions = this.positionName.split('/');
                if (substitutablePlayer.positionInLineup === Const.POSITION_CFB_NAMES.fanduel.SUPERFLEX) {
                    return substitutePlayerLineupPositions.some((position) =>
                        inArray(position, ['QB', 'RB', 'WR', 'TE']),
                    );
                } else if (substitutablePlayer.positionInLineup === 'WR') {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['WR', 'TE']));
                }

                return substitutePlayerLineupPositions.some(
                    (position) => substitutablePlayer.positionInLineup === position,
                );
            },
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
        };
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('teamNameStacking')) {
            dispatch(Action.setTeamNameStackingFromStorage(data.teamNameStacking));
        }

        if (data.hasOwnProperty('flexMaxExposurePositions')) {
            dispatch(Action.set('FlexMaxExposurePositionsFromStorage', data.flexMaxExposurePositions));
        }

        if (data.hasOwnProperty('superFlexMaxExposurePositions')) {
            dispatch(Action.set('SuperFlexMaxExposurePositionsFromStorage', data.superFlexMaxExposurePositions));
        }
    }
}
